import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { CadMaterialsClient } from "./apiClient";

const cadMaterialsClient = new CadMaterialsClient(undefined, axios);

export const useCadMaterials = (options?: any) => {
  return useQuery<string[]>({
    ...options,
    queryKey: ["cadMaterials"],
    queryFn: async () => cadMaterialsClient.getCadMaterials(),
  });
};
